import tw from 'twin.macro';

const Grid = tw.div`grid grid-cols-1 md:grid-cols-2 md:gap-x-8 xl:grid-cols-3 xl:gap-x-11 gap-y-7`;

export default Grid;
